<h2 mat-dialog-title style="text-align: center; font-family: akzidenz-grotesk-bold; font-size: x-large;">{{'D_T2' | translate}}</h2>
<mat-dialog-content class="mat-typography" style="font-size: xx-large;">
    <div *ngIf="!data.showTime">
        <h3 *ngIf="data.correctness" style="text-align: center; font-size: x-large;">{{'CORRECT' | translate}}</h3>
        <h3 *ngIf="!data.correctness" style="text-align: center; font-size: x-large;">{{'WRONG' | translate}}</h3>
    </div>
    
    <div *ngIf="data.showTime">
        
        <div *ngIf="data.responseTime > 0">
            <h3 *ngIf="data.correctness" style="text-align: center; font-size: x-large;">{{'CORRECT' | translate}}</h3>
            <h3 *ngIf="!data.correctness" style="text-align: center; font-size: x-large;">{{'WRONG' | translate}}</h3>
            <h3 >{{'D_P3' | translate}}: {{data.responseTime}} ms</h3>
        </div>
        <div *ngIf="data.responseTime === 0">
            <h3 style="text-align: center;  font-size: x-large;">{{'D_P4' | translate}}</h3>
            <h3 style="font-size: x-large;">{{'D_P5' | translate}}</h3>
        </div>
    </div>

</mat-dialog-content>
